module.exports = __webpack_public_path__ + "img/SEND.2a01923a.svg";